// removed by extract-text-webpack-plugin
module.exports = {"tableWrapper":"src-components-ClassList__tableWrapper--1bDbX","table":"src-components-ClassList__table--2EEfX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClassList.scss
// module id = 74
// module chunks = 0